import { DASHBOARD_DATA_URL } from "../constants";
import { apiSlice } from "./apiSlice";

const dashBoardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionsForDashboard: builder.query({
      query: (data) => ({
        url: `${DASHBOARD_DATA_URL}/getSubscriptionsForDashboard?${
          data.query ? data.query : ""
        }`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getVisitorsForDashboard: builder.query({
      query: (data) => ({
        url: `${DASHBOARD_DATA_URL}/getVisitorsForDashboard?${
          data.query ? data.query : ""
        }`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getPaymentsForDashboard: builder.query({
      query: (data) => ({
        url: `${DASHBOARD_DATA_URL}/getPaymentsForDashboard?${
          data.query ? data.query : ""
        }`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getDashboardSummary: builder.query({
      query: (data) => ({
        url: `${DASHBOARD_DATA_URL}/getDashboardSummary?from=${data.from}&to=${data.to}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getMemberWiseAnalytics: builder.query({
      query: (data) => ({
        url: `${DASHBOARD_DATA_URL}/getMemberWiseAnalytics?${
          data.query ? data.query : ""
        }`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useGetDashboardSummaryQuery,
  useGetSubscriptionsForDashboardQuery,
  useGetVisitorsForDashboardQuery,
  useGetPaymentsForDashboardQuery,
  useGetMemberWiseAnalyticsQuery,
} = dashBoardApiSlice;
